import { pluralise } from "repoV2/features/Common/utils/strings";
import { COURSE_END_CHOICE } from "repoV2/features/Listing/Listing.constants";

/**
 * This function returns the short description for subscription type
 * @param param0 courseMagnitudeCount { number } - subscription magnitude count - total count of days or weeks or months
 * @param param1 courseMagnitudeChoice { number } - subscription choice - days or weeks or months
 * @returns string containing the short description
 */
export const getSubscriptionShortDescription = ({
    courseMagnitudeCount,
    courseMagnitudeChoice,
}: {
    courseMagnitudeCount: number;
    courseMagnitudeChoice: number;
}) => {
    const suffix = {
        [COURSE_END_CHOICE.DAYS]: "Day",
        [COURSE_END_CHOICE.WEEKS]: "Week",
        [COURSE_END_CHOICE.MONTHS]: "Month",
    };

    return `${courseMagnitudeCount} ${pluralise(
        suffix[courseMagnitudeChoice],
        courseMagnitudeCount
    )} Subscription`;
};

export const getShortDescriptionValidityText = ({
    courseMagnitudeCount,
    courseMagnitudeChoice,
}: {
    courseMagnitudeCount: number;
    courseMagnitudeChoice: number;
}) => {
    const suffix = {
        [COURSE_END_CHOICE.DAYS]: "Day",
        [COURSE_END_CHOICE.WEEKS]: "Week",
        [COURSE_END_CHOICE.MONTHS]: "Month",
    };

    return `Valid for ${courseMagnitudeCount} ${pluralise(
        suffix[courseMagnitudeChoice],
        courseMagnitudeCount
    )}`;
};
